import ReasonForLoan from './reason-for-loan';

export default ReasonForLoan;